<!--
 * @Description: 
 * @Author: 
 * @Date: 2021-11-18 17:51:20
 * @LastEditTime: 2023-09-12 09:55:29
 * @LastEditors: dongqianqian
 * @Usage: 
-->
<template>
  <div>
    <HeadTop />
    <div class="conBG">
      <ul class="menuList">
        <li
          v-for="(item,index) in list"
          :key="item.id"
          :class="{'active':navIndex==index}"
          @click="navIndex=index; to(item)"
        >
          {{item.name}}</li>
        <div style="clear:both;"></div>
      </ul>
      <router-view />
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/header.vue'
export default {
  data() {
    return {
      navIndex: 0,
      list: [{
        id: 'groupinfo',
        name: '公司信息'
      },
      {
        id: 'groupbranchcompany',
        name: '分公司管理'
      },
      {
        id: 'groupdepart',
        name: '部门管理'
      },
      {
        id: 'groupproject',
        name: '工程管理'
      },
      {
        id: 'grouprole',
        name: '角色管理'
      },
      {
        id: 'grouppreson',
        name: '人员管理'
      },
      {
        id: 'groupsetting',
        name: '配置管理'
      },
      {
        id: 'projectprovince',
        name: '项目菜单管理'
      }
      ],
    }
  },
  components: {
    HeadTop
  },
  methods: {
    to(v) {
      this.$router.push({
        name: v.id
      })
    }
  }
}
</script>

<style>
</style>